export const tags = [
    'WindowCenter',
    'WindowWidth',
    'VOILUTFunction',
    'WindowCenterWidthExplanation',
];
